import { render } from "./newsList.vue?vue&type=template&id=55b8aa93&ts=true"
import script from "./newsList.vue?vue&type=script&lang=ts&config=true"
export * from "./newsList.vue?vue&type=script&lang=ts&config=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__